<template>
    <div>
        <table>
            <tbody>
                <tr>
                    <td>Status:</td>
                    <td v-if="loading">lade...</td>
                    <td v-else>{{ status }}</td>
                </tr>
                <tr>
                    <td>Stand:</td>
                    <td>{{ lastCheck }}</td>
                </tr>
                <tr>
                    <td><label for="Range">Zeitraum:</label></td>
                    <td>
                        <select id="Range" @change="getDynamic" :disabled="loading">
                            <option value="all">alle</option>
                            <option value="today">heute</option>
                            <option value="thisWeek">diese Woche</option>
                            <option value="lastWeek">letzte Woche</option>
                            <option value="thisMonth">dieser Monat</option>
                            <option value="lastMonth">letzter Monat</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td>Ausfälle:</td>
                    <td>{{ countOffline }}</td>
                </tr>
                <tr>
                    <td>Online total:</td>
                    <td>{{ totalOnline }} min.</td>
                </tr>
                <tr>
                    <td>Offline total:</td>
                    <td>{{ totalOffline }} min.</td>
                </tr>
            </tbody>
        </table>

        <p v-if="loading">lade...</p>
        <table v-else class="table--logs">
            <thead>
                <tr>
                    <th>Datum</th>
                    <th>Status</th>
                    <th>Dauer</th>
                    <th>({{max}} Minuten)</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="entry in logs" :key="entry.id">
                    <td>{{ entry.locale }}</td>
                    <td>{{ entry.status }}</td>
                    <td><span v-if="entry.duration">{{ entry.duration }} min.</span></td>
                    <td>
                        <div class="bar">
                            <div class="duration" :style="{width: barPercentage(entry.duration)}" :class="entry.status"></div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'logs-table',
    data() {
        return {
            logs: [],
            loading: true,
            lastCheck: false,
            online: false,
            format: 'YYYY-MM-DD HH:mm',
            url: 'https://fb.tornography.com/json.php',
            max: 0,
            totalOnline: 0,
            totalOffline: 0
        };
    },
    computed: {
        status() {
            return this.online ? 'online' : 'offline';
        },
        all() {
            return false;
        },
        today() {
            return { start: moment().startOf('day').unix() };
        },
        yesterday() {
            let day = {};
            day.start = moment().startOf('day').subtract(1, 'days').unix();
            day.end = moment().startOf('day').unix();
            return day;
        },
        oneWeek() {
            return { start: moment().subtract(1, 'weeks').unix() };
        },
        thisWeek() {
            return { start: moment().startOf('isoWeek').unix() };
        },
        lastWeek() {
            let week = {};
            week.start = moment().startOf('isoWeek').subtract(1, 'weeks').unix();
            week.end = moment().startOf('isoWeek').unix();
            return week;
        },
        thisMonth() {
            return { start: moment().startOf('month').unix() };
        },
        lastMonth() {
            let month = {};
            month.start = moment().startOf('month').subtract(1, 'months').unix();
            month.end = moment().startOf('month').unix();
            return month;
        },
        countOffline() {
            return this.logs.filter(l => l.status === 'offline').length;
        }
    },
    methods: {
        resetStates() {
            this.max = 0;
            this.totalOffline = 0;
            this.totalOnline = 0;
        },
        getDynamic(e) {
            this.resetStates();
            this.fetchLogs(this[e.target.value]);
        },
        fetchLogs(params) {
            this.loading = true;
            this.$http.get(this.url, {params: params})
                .then((response) => {
                    this.logs = response.data.logs.map((entry, index, array) => {
                        let duration = 0;
                        if (array[index - 1]) {
                            duration = Math.round(moment.duration(array[index - 1].time - entry.time, 'seconds').asMinutes());
                        }

                        if (duration > this.max) {
                            this.max = duration;
                        }

                        if (entry.status === 0) {
                            this.totalOffline = this.totalOffline + duration;
                        } else {
                            this.totalOnline = this.totalOnline + duration;
                        }

                        entry.duration = duration;
                        entry.locale = this.unixToFormat(entry.time);
                        entry.status = this.readableStatus(entry.status);

                        // console.log(entry);
                        return entry;
                    });
                    this.online = response.data.online;
                    this.lastCheck = moment().format(this.format);
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        unixToFormat(time) {
            return moment(time * 1000).format(this.format);
        },
        readableStatus(status) {
            return status === 1 ? 'online' : 'offline';
        },
        pluralize(count, singular, plural) {
            switch (count) {
                case 1:
                    return singular;
                default:
                    return plural;
            }
        },
        barPercentage(value) {
            return value * 100 / this.max + '%';
        }
    },
    created() {
        this.fetchLogs();
    }
};
</script>

<style lang="scss" scoped>
    table {
        border-collapse: collapse;
    }

    .table--logs {
        width: 100%;
    }

    .table--logs th,
    .table--logs td {
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3), {
            width: 10px;
        }
    }

    .table--logs {
        th:nth-child(4),
        td:nth-child(4) {
            display: none;
            @media (min-width: 32em) {
                display: table-cell;
            }
        }
    }
    .table--logs th {
        text-align: left;
        padding: 0.5em;
    }
    .table--logs td {
        padding: 0 0.5em;
        white-space: nowrap;
    }

    .table--logs tbody tr:nth-child(2n) {
        background-color: rgb(231, 231, 231);
    }

    .table--logs td:nth-child(3) {
        text-align: end;
    }

    .bar {
        height: 1em;
        width: 100%;
        background-color: rgb(190, 190, 190);
    }

    .duration {
        height: 100%;
        min-width: 1px;
        background-color: green;
    }

    .duration.offline {
        background-color: rgb(128, 0, 0);
    }

</style>



// WEBPACK FOOTER //
// src/pages/LogsTable.vue